import { CheckCircleOutline, Euro, Event, Redeem  } from "@mui/icons-material";
import useCourse from "../utils/useCourse";
import useProduct from "../utils/useProduct";
import Total from "./Total";
import useDpcSession from "../utils/useDpcSession";
import { sessionLabel } from "./DpcSessions";
import useCart from "../utils/useCart";
import { useParams } from "react-router-dom";
import EmptyCart from "./EmptyCart";
import useReward from "../utils/useReward";
import MobileHelp from "./MobileHelp";
import { txt } from "../../../services/translation";

export default function Cart(){

    const { id } = useParams()

    const { cart } = useCart()

    const course = useCourse()

    const product = useProduct()

    const session = useDpcSession()

    const reward = useReward()

    if( !id ) return <EmptyCart />;

    return course &&

        <article className="apply-cart">

                {course.picture?.url &&
                    <img
                        src={course.picture?.url}
                        alt={course.title}
                        className="apply-cart-img"
                    />
                }

                <div className="apply-cart-content">

                
                    <span className="apply-cart-title">
                        {course.title}
                    </span>

                    {!cart.isCompleted && <>


                        {(!course?.free && product) &&
                        
                            <div className="apply-cart-info">

                                <Euro sx={iconSx} />

                                <span>Financement :</span>

                                <span className="apply-badge-dark">
                                    {['dpc','dpc-pi'].includes(product?.variant?.id) ? 'DPC' : product.variant.title}
                                </span>

                            </div>
                        }

                        
                        {session && 
                        
                            <div className="apply-cart-info">

                                <Event sx={iconSx} />

                                <span>Session :</span>

                                <span className="apply-badge-dark">
                                    {sessionLabel(session)}
                                </span>

                            </div>

                        }


                        {reward && 
                        
                            <div className="apply-cart-info">

                                <Redeem sx={iconSx} />

                                <span>Cadeau :</span>

                                <span className="apply-badge-dark">
                                    {reward.title.substring(0, 20)} {reward.title.length > 20 ? '...' : ''}
                                </span>

                            </div>

                        }


                    </>}

                    <div className="apply-mobile-hidden">

                        <div className="apply-cart-info">

                            <CheckCircleOutline sx={iconSx} />

                            <span>{txt('lifetimeAccess')}</span>

                            <span></span>

                        </div>

                        <div className="apply-cart-info">

                            <CheckCircleOutline sx={iconSx} />

                            <span>{txt('administrativeProcedures')}</span>

                        </div>
                    
                    
                        <Total />

                    </div>

                    <MobileHelp />

                </div>

        </article>
}

export const iconSx = {
    fontSize: 22
}